<p-dialog [(visible)]="visible" [modal]="true" [closable]="true" (onHide)="onDialogHide()" [header]="'payment.addCardCop' | transloco">
  <ng-container *ngIf="loading">
    <div class="spinner-container">
      <p-progress-spinner ariaLabel="loading" />
    </div>
  </ng-container>
  <div id="payment-form-container" [style.display]="loading ? 'none' : 'block'"></div>
</p-dialog>